<template>
  <div
    v-click-outside="onClickOutside"
    v-esc="escape"
    class="fixed-sidebar"
    :class="{open: openMenu}"
  >
    <div
      id="sidebar-left"
      class="fixed-sidebar-left sidebar--small"
    >
      <a
        href="#"
        class="logo"
      >
        <div class="img-wrap" /></a>
      <div
        ref="scroll"
        data-mcs-theme="dark"
        class="mCustomScrollbar"
      >
        <sidebar-personal
          v-if="ppa==='per'"
          @openmenu="onOpenMenu"
        />
        <sidebar-familial
          v-if="ppa==='fam'"
          @openmenu="onOpenMenu"
        />
        <sidebar-financial
          v-if="ppa==='fin'"
          @openmenu="onOpenMenu"
        />
        <sidebar-physical
          v-if="ppa==='phy'"
          @openmenu="onOpenMenu"
        />
        <sidebar-mental
          v-if="ppa==='men'"
          @openmenu="onOpenMenu"
        />
        <sidebar-social
          v-if="ppa==='soc'"
          @openmenu="onOpenMenu"
        />
        <sidebar-spiritual
          v-if="ppa==='spi'"
          @openmenu="onOpenMenu"
        />
        <sidebar-vocational
          v-if="ppa==='voc'"
          @openmenu="onOpenMenu"
        />
      </div>
    </div>
    <div
      id="sidebar-left-1"
      class="fixed-sidebar-left sidebar--large"
    >
      <a
        href="#"
        class="logo"
      >
        <div class="img-wrap" />
        <div class="title-block">
          <h6 class="logo-title">The Orangegirl V2</h6>
        </div></a>
      <div
        ref="scroll1"
        data-mcs-theme="dark"
        class="mCustomScrollbar"
      >
        <sidebar-personal-large
          v-if="ppa==='per'"
          @openmenu="onOpenMenu"
        />
        <sidebar-familial-large
          v-if="ppa==='fam'"
          @openmenu="onOpenMenu"
        />
        <sidebar-financial-large
          v-if="ppa==='fin'"
          @openmenu="onOpenMenu"
        />
        <sidebar-mental-large
          v-if="ppa==='men'"
          @openmenu="onOpenMenu"
        />
        <sidebar-physical-large
          v-if="ppa==='phy'"
          @openmenu="onOpenMenu"
        />
        <sidebar-social-large
          v-if="ppa==='soc'"
          @openmenu="onOpenMenu"
        />
        <sidebar-spiritual-large
          v-if="ppa==='spi'"
          @openmenu="onOpenMenu"
        />
        <sidebar-vocational-large
          v-if="ppa==='voc'"
          @openmenu="onOpenMenu"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import '../../../js/jquery-3.2.1'
// import '../../../js/material.min'
// import '../../../js/material-init'

// import '../../js/jquery.mousewheel';
// eslint-disable-next-line
  import Ps from 'perfect-scrollbar';
import VueEsc from 'vue-esc'
import vClickOutside from 'v-click-outside'
import Vue from 'vue'
Vue.use(VueEsc);
Vue.use(vClickOutside);
// eslint-disable-next-line
import '../../../css/perfect-scrollbar.css'
// import AppIconMultiple from './AppIconMultiple'
// import AppIcon from './AppIcon'
import SidebarPersonal from './left-sidebar/Personal'
import SidebarPersonalLarge from './left-sidebar/PersonalLarge'
import SidebarMental from './left-sidebar/Mental'
import SidebarMentalLarge from './left-sidebar/MentalLarge'
import SidebarFamilial from './left-sidebar/Familial'
import SidebarFamilialLarge from './left-sidebar/FamilialLarge'
import SidebarFinancial from './left-sidebar/Financial'
import SidebarFinancialLarge from './left-sidebar/FinancialLarge'
import SidebarPhysical from './left-sidebar/Physical'
import SidebarPhysicalLarge from './left-sidebar/PhysicalLarge'
import SidebarSocial from './left-sidebar/Social'
import SidebarSocialLarge from './left-sidebar/SocialLarge'
import SidebarSpiritual from './left-sidebar/Spiritual'
import SidebarSpiritualLarge from './left-sidebar/SpiritualLarge'
import SidebarVocational from './left-sidebar/Vocational'
import SidebarVocationalLarge from './left-sidebar/VocationalLarge'

export default {
  name: 'LeftSidebar',
  components: {  SidebarPersonal, SidebarMental, SidebarVocational,
    SidebarPersonalLarge, SidebarMentalLarge, SidebarVocationalLarge,
    SidebarFamilial, SidebarFamilialLarge, SidebarFinancial, SidebarFinancialLarge,
    SidebarPhysical, SidebarPhysicalLarge, SidebarSocial, SidebarSocialLarge,
    SidebarSpiritual, SidebarSpiritualLarge},
  props: {
    options: {
      type: Object,
      default () {
        return {
          suppressScrollX: true
        }
      }
    },
    ppa: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      openMenu: false
    }
  },
  computed: {},
  mounted () {
    // eslint-disable-next-line
      new Ps(this.$refs.scroll, this.options);
    // eslint-disable-next-line
      new Ps(this.$refs.scroll1, this.options);
    // eslint-disable-next-line
      // console.log(aa.element);
  },
  methods: {
    onOpenMenu(val) {
      this.openMenu = val
    },
    escape () {
      this.openMenu = false
    },
    onClickOutside () {
      this.openMenu = false
    },
    update () {
      Ps.update(this.$refs.scroll)
      Ps.update(this.$refs.scroll1)
    },
  }
}
</script>
